import "core-js/modules/es.promise.js";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withKeys as _withKeys } from "vue";
var _hoisted_1 = {
  id: "pum-root"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["innerHTML"];
var _hoisted_4 = {
  class: "tw-p-0"
};
var _hoisted_5 = ["innerHTML"];
var _hoisted_6 = {
  key: 0,
  class: "tw-text-10 tw-text-white tw-bg-w-primary tw-inline-flex tw-items-center tw-justify-center tw-rounded tw-w-7 tw-h-5 tw-relative"
};
var _hoisted_7 = {
  key: 1,
  class: "tw-bg-w-danger/15 tw-size-5 tw-rounded-circle tw-border tw-border-solid tw-border-w-danger tw-p-0 tw-flex tw-items-center tw-justify-center tw-text-w-danger"
};
var _hoisted_8 = ["innerHTML"];
var _hoisted_9 = {
  key: 1,
  class: "tw-hidden sm:tw-block tw-p-0 tw-m-0"
};
var _hoisted_10 = {
  class: "tw-flex tw-w-full tw-items-center tw-justify-end tw-flex-nowrap"
};
var _hoisted_11 = ["innerHTML"];
var _hoisted_12 = ["innerHTML"];
import { computed, ref, watch } from "vue";
import { setActionAndRedirect } from "@vueEntry/composables/useUserAction";
import BaseDropDown from "@vueEntry/UIKitComponents/BaseDropDown.vue";
import { ProfileIcon } from "@vueEntry/SvgIcons/ProfileIcon";
import { HeartIcon } from "@vueEntry/SvgIcons/HeartIcon";
import { RequestIcon } from "@vueEntry/SvgIcons/RequestIcon";
import { BellIcon } from "@vueEntry/SvgIcons/BellIcon";
import { ValuationIcon } from "@vueEntry/SvgIcons/ValuationIcon";
import { ListingsIcon } from "@vueEntry/SvgIcons/ListingsIcon";
import { LogoutIcon } from "@vueEntry/SvgIcons/LogoutIcon";
import SelectItem from "@vueEntry/UIKitComponents/BaseSelect/SelectItem.vue";
import { usePublicUserMenuStore } from "@store/PublicUserMenuStore";
import { useLoggedUserStore } from "@store/LoggedUserStore";
import { useModalStore } from "@store/ModalStore";
import { useBaseStore } from "@store/BaseStore";
import { ArrowIcon } from "@vueEntry/SvgIcons/ArrowIcon";
import { useKeyboardController } from "@wkComposables/useKeyboardController";
import { useCommonVars } from "@wkComposables/useCommonVars";
import { Modals } from "@customTypes/Modals";
export default /*#__PURE__*/_defineComponent({
  __name: 'PublicUserMenu',
  props: {
    privateUrl: {},
    headerWhite: {
      type: Boolean,
      default: false
    },
    menuItems: {},
    isInsight: {
      type: Boolean,
      default: false
    },
    isTrend: {
      type: Boolean,
      default: false
    },
    labels: {},
    wikicasaProLogin: {
      type: Boolean,
      default: false
    }
  },
  emits: ["logout"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var props = __props;
    var emits = __emit;
    var openDropdown = ref(false);
    watch(openDropdown, cur => {
      if (!cur) activeIdx.value = -1;
    });
    var {
      activeIdx
    } = useKeyboardController({
      optionsLength: 7,
      isDropdownOpen: openDropdown
    });
    var publicUserMenuStore = usePublicUserMenuStore();
    var loggedUserStore = useLoggedUserStore();
    var modalStore = useModalStore();
    var baseStore = useBaseStore();
    var {
      baseURL
    } = useCommonVars();
    var welcomeBackLabel = computed(() => "".concat(props.menuItems.user.label, " ").concat(publicUserMenuStore.name));
    var fullPrivateUrl = computed(() => "".concat(baseURL.value, "/").concat(props.privateUrl));
    //Need them because at the time of the creation of the component the store is not yet "ready" so the counter result to be undefined
    var favoritesCounter = computed(() => publicUserMenuStore.favoritesCounter);
    var requestsCounter = computed(() => publicUserMenuStore.requestsCounter);
    var savedSearchesCounter = computed(() => publicUserMenuStore.savedSearchesCounter);
    var listingRequestsCount = computed(() => publicUserMenuStore.listingRequestsCount);
    var menuItemsToSelect = ref([{
      iconComponent: ProfileIcon,
      itemLabel: props.menuItems.profile.label,
      itemUrl: props.menuItems.profile.url,
      mailConfirmedIcon: publicUserMenuStore.mailConfirmed,
      isLink: true
    }, {
      iconComponent: HeartIcon,
      itemLabel: props.menuItems.favorites.label,
      itemUrl: props.menuItems.favorites.url,
      itemCounter: favoritesCounter,
      isLink: true
    }, {
      iconComponent: RequestIcon,
      itemLabel: props.menuItems.requests.label,
      itemUrl: props.menuItems.requests.url,
      itemCounter: requestsCounter
    }, {
      iconComponent: BellIcon,
      itemLabel: props.menuItems.savedSearches.label,
      itemUrl: props.menuItems.savedSearches.url,
      itemCounter: savedSearchesCounter
    }, {
      iconComponent: ValuationIcon,
      itemLabel: props.menuItems.valuation.label,
      itemUrl: props.menuItems.valuation.url
    }, {
      iconComponent: ListingsIcon,
      itemLabel: props.menuItems.listings.label,
      itemUrl: props.menuItems.listings.url,
      itemCounter: listingRequestsCount
    }]);
    var openModalOrRedirectPro = login => {
      props.wikicasaProLogin ? window.open("".concat(baseURL.value, "/pro/login")) : login ? modalStore.setShowModal(Modals.loginModal) : modalStore.setShowModal(Modals.signInModal);
    };
    var logout = () => __awaiter(this, void 0, void 0, function* () {
      yield baseStore.logout();
      setActionAndRedirect();
      emits("logout");
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(publicUserMenuStore).name && _unref(loggedUserStore).isUserLogged ? (_openBlock(), _createBlock(BaseDropDown, {
        key: 0,
        id: "pum-dropdown",
        "data-cy": "pum-dropdown",
        "dropdown-classes": "tw-z-[1042] tw-shadow !tw-rounded-xs tw-mt-10px !tw-max-h-fit !tw-min-w-[200px] tw-right-0",
        "open-dropdown": openDropdown.value,
        "dropdown-element": "ul",
        "onUpdate:dropdownState": _cache[2] || (_cache[2] = v => openDropdown.value = v)
      }, {
        btn_slot: _withCtx(_ref2 => {
          var {
            toggleDropdown,
            isOpen
          } = _ref2;
          return [_createElementVNode("div", {
            class: "tw-flex tw-items-center tw-cursor-pointer tw-p-2",
            onClick: _withModifiers(toggleDropdown, ["stop"])
          }, [_createVNode(_unref(ProfileIcon), {
            width: 20,
            height: 20,
            class: "tw-inline-block tw-mr-10px",
            "stroke-color": _ctx.headerWhite && !_ctx.isInsight ? '#2b5dff' : '#fff'
          }, null, 8 /* PROPS */, ["stroke-color"]), _createElementVNode("button", {
            "data-cy": "pum-dropdown-btn",
            type: "button",
            class: _normalizeClass("tw-bg-transparent ".concat(_ctx.headerWhite && !_ctx.isInsight ? 'tw-text-w-primary' : 'tw-text-white header-white', " tw-mr-20px tw-text-16 tw-font-semibold"))
          }, [_createElementVNode("span", {
            innerHTML: welcomeBackLabel.value
          }, null, 8 /* PROPS */, _hoisted_3)], 2 /* CLASS */), _createVNode(_unref(ArrowIcon), {
            class: _normalizeClass(["tw-transition-transform motion-reduce:tw-transition-none tw-shrink-0", isOpen && 'tw-rotate-180']),
            width: 15,
            height: 15,
            "stroke-color": _ctx.headerWhite && !_ctx.isInsight ? '#2b5dff' : '#fff'
          }, null, 8 /* PROPS */, ["class", "stroke-color"])], 8 /* PROPS */, _hoisted_2)];
        }),
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItemsToSelect.value, (item, idx) => {
          return _openBlock(), _createBlock(SelectItem, {
            key: "pum_item_".concat(idx),
            class: "tw-relative",
            active: _unref(activeIdx) === idx,
            onMouseover: $event => activeIdx.value = idx
          }, {
            default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(publicUserMenuStore).mailConfirmed || item.isLink ? 'a' : 'div'), {
              class: _normalizeClass(["tw-flex tw-justify-between tw-items-center tw-no-underline tw-py-10px tw-px-20px tw-my-1", [{
                'tw-text-gray-300': _unref(publicUserMenuStore).mailConfirmed === false && !item.isLink
              }, {
                'tw-cursor-pointer': _unref(publicUserMenuStore).mailConfirmed
              }]]),
              href: (_unref(publicUserMenuStore).mailConfirmed || item.isLink) && "".concat(fullPrivateUrl.value, "/").concat(item.itemUrl),
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_resolveDynamicComponent(item.iconComponent), {
                height: 15,
                width: 15,
                class: "tw-align-middle tw-mr-10px tw-inline-block",
                "stroke-color": item.isLink || _unref(publicUserMenuStore).mailConfirmed ? '#222' : '#d1d5db'
              }, null, 8 /* PROPS */, ["stroke-color"])), _createElementVNode("span", {
                class: "tw-p-0 tw-capitalize",
                innerHTML: item.itemLabel
              }, null, 8 /* PROPS */, _hoisted_5)]), item.itemCounter && item.itemCounter > 0 && _unref(publicUserMenuStore).mailConfirmed ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.itemCounter), 1 /* TEXT */)) : _createCommentVNode("v-if", true), _unref(publicUserMenuStore).mailConfirmed === false && item.itemUrl === props.menuItems.profile.url ? (_openBlock(), _createElementBlock("span", _hoisted_7, "!")) : _createCommentVNode("v-if", true)]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["class", "href"]))]),
            _: 2 /* DYNAMIC */
          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["active", "onMouseover"]);
        }), 128 /* KEYED_FRAGMENT */)), _createCommentVNode(" Logout item "), _createVNode(SelectItem, {
          class: "tw-bg-w-lavender tw-m-0 [&.active]:!tw-bg-[#C5D4FC] hover:!tw-bg-[#C5D4FC]",
          active: _unref(activeIdx) === menuItemsToSelect.value.length,
          onMouseover: _cache[1] || (_cache[1] = $event => activeIdx.value = menuItemsToSelect.value.length),
          onKeydown: _withKeys(logout, ["enter"])
        }, {
          default: _withCtx(() => [_createElementVNode("button", {
            id: "logout-wrapper",
            "data-cy": "pum-logout-btn",
            type: "button",
            class: "tw-bg-transparent tw-flex tw-items-center tw-py-10px tw-px-20px tw-mt-1 tw-cursor-pointer tw-w-full",
            onClick: _withModifiers(logout, ["stop"])
          }, [_createVNode(_unref(LogoutIcon), {
            height: 15,
            width: 15,
            class: "tw-align-middle tw-mr-10px tw-inline-block"
          }), _createElementVNode("span", {
            class: "tw-p-0 tw-text-w-primary",
            innerHTML: _ctx.menuItems.logout.label
          }, null, 8 /* PROPS */, _hoisted_8)])]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["active"])]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["open-dropdown"])) : _unref(loggedUserStore).isUserLogged === false ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("button", {
        id: "login-menu-button",
        class: "tw-cursor-pointer tw-bg-transparent tw-px-15px tw-py-10px tw-text-w-primary tw-font-semibold tw-items-center tw-no-underline",
        onClick: _cache[3] || (_cache[3] = $event => openModalOrRedirectPro(true))
      }, [_createElementVNode("span", {
        class: _normalizeClass([_ctx.headerWhite ? 'tw-text-w-primary' : 'tw-text-white', {
          'tw-text-white': _ctx.isInsight
        }]),
        innerHTML: _ctx.labels.login
      }, null, 10 /* CLASS, PROPS */, _hoisted_11)]), _createElementVNode("button", {
        id: "register-menu-button",
        class: _normalizeClass(["tw-cursor-pointer tw-btn tw-btn-sm tw-rounded tw-border tw-border-solid tw-text-w-primary tw-font-semibold tw-flex tw-items-center lg:tw-mg-15px", [{
          'tw-bg-white': _ctx.isInsight
        }, {
          'tw-border-w-primary': _ctx.headerWhite && !_ctx.isTrend && !_ctx.isInsight
        }, {
          'tw-border-white tw-bg-white': !_ctx.headerWhite || _ctx.isTrend
        }]]),
        onClick: _cache[4] || (_cache[4] = $event => openModalOrRedirectPro(false)),
        innerHTML: _ctx.labels.signin
      }, null, 10 /* CLASS, PROPS */, _hoisted_12)])])) : _createCommentVNode("v-if", true)]);
    };
  }
});